import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadDealers,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import { DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { getIntDealers, GetINTDealersApiParameter } from "@tIntermatic/Services/IntDealerService";

type HandlerType = ApiHandler<GetINTDealersApiParameter, DealerCollectionModel>;

export const IntPopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const IntRequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getIntDealers(props.apiParameter);
};

export const IntDispatchCompleteLoadDealers: HandlerType = props => {
    props.dispatch({
        type: "Data/Dealers/CompleteLoadDealers",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

replaceInChain(chain, PopulateApiParameter, IntPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, IntRequestDataFromApi);
replaceInChain(chain, DispatchCompleteLoadDealers, IntDispatchCompleteLoadDealers);
